import { render, staticRenderFns } from "./CuponUsesList.vue?vue&type=template&id=498aa4e8&scoped=true&"
import script from "./CuponUsesList.vue?vue&type=script&lang=js&"
export * from "./CuponUsesList.vue?vue&type=script&lang=js&"
import style0 from "./CuponUsesList.vue?vue&type=style&index=0&id=498aa4e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498aa4e8",
  null
  
)

export default component.exports